module.exports = __webpack_public_path__ + "static/media/lb-banner.21701f8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/lb-banner.png
// module id = 645
// module chunks = 0